module.exports = __webpack_public_path__ + "img/pose-m-11.00857afa.svg";